<ng-container *ngIf="layout === 'empty'">

    <!-- Loading bar -->
    <!-- <fuse-loading-bar></fuse-loading-bar> -->

    <!-- Wrapper -->
    <div class="flex flex-col flex-auto w-full">

        <!-- Content -->
        <div class="flex flex-col flex-auto">
            <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
            <!-- <router-outlet *ngIf="true"></router-outlet> -->
            <router-outlet></router-outlet>
        </div>

    </div>

</ng-container>


<ng-container *ngIf="layout !== 'empty'">
    <ng-container *transloco="let t">
        <!-- Navigation -->
        <fuse-vertical-navigation class="dark bg-dark-900 dark:bg-dark2-500 print:hidden rounded-3xl "
            [appearance]="navigationAppearance" [mode]="!this.app?.screen.md ? 'over' : 'side'" [name]="'mainNavigation'"
            [navigation]="navigation" [opened]="this.app?.screen.md">

            <ng-container fuseVerticalNavigationContentHeader>
                <!-- Logo -->
                <div class="flex items-center justify-center h-16 mb-4">
                    <img class="w-8" [src]="app?.config?.logo?.menu" alt="Logo image">
                </div>



            </ng-container>
        </fuse-vertical-navigation>

        <!-- Wrapper -->
        <div class="flex flex-col flex-auto w-full min-w-0">

            <div class="relative flex flex-0 items-center w-full h-10  bg-primary-500 dark:bg-default print:hidden"
                *ngIf="app?.isNative">
            </div>

            <!-- Header -->
            <header class="relative flex flex-0 items-center w-full py-2 sm:py-3  px-3 z-49 bg-default print:hidden"
                *ngIf="app?.screen.md">


                <!-- Logo -->
                <div class="flex items-center h-10 ">
                    <!-- Light version -->
                    <img class="dark:hidden h-10" [src]="app?.config?.logo?.mainLight" alt="Logo image">
                    <!-- Dark version -->
                    <img class="hidden dark:flex h-10" [src]="app?.config?.logo?.mainDark" alt="Logo image">
                </div>




                <!-- Components -->
                <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
                    <!-- <languages></languages> -->
                    <!-- <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
                            <search [appearance]="'bar'"></search>

                            <messages></messages> -->
                    <!-- <button
                                class="lg:hidden"
                                mat-icon-button
                                (click)="quickChat.toggle()">
                                <mat-icon [svgIcon]="'heroicons_outline:chat-alt-2'"></mat-icon>
                            </button> -->

                    <!-- <shortcuts></shortcuts> -->
                    <!-- <button mat-icon-button (click)="toggleNavigation('mainNavigation')" [matTooltip]="t('Apps')">
                        <mat-icon [svgIcon]="'mat_outline:apps'"></mat-icon>
                    </button> -->

                    @if(app?.menuActions){
                    @for (item of app?.menuActions; track $index) {

                    @if(item.position === 'header-right' && item.style === 'mat-icon-button'){
                    <button mat-icon-button (click)="app?.emitAny(item.event)" [matTooltip]="t(item.tooltip)" [color]="item.color">
                        <mat-icon [svgIcon]="item.icon"></mat-icon>
                    </button>

                    }
                    }
                    }

                    <!-- @if(app?.credential?.userType?.code === 3){
                    <a mat-icon-button routerLink="/settings" [matTooltip]="t('Settings')">
                        <mat-icon svgIcon="mat_outline:settings"></mat-icon>
                    </a>
                    } -->

                    <auth-menu></auth-menu>
                </div>
            </header>

            <!-- Content -->
            <div class="flex flex-col flex-auto">
                <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
                <!-- <router-outlet *ngIf="true"></router-outlet> -->
                <router-outlet></router-outlet>
            </div>


            <!-- Footer -->
            <div class="relative flex flex-0 items-center justify-between w-full pt-2   px-6 z-49   bg-default  print:hidden"
                [class.pb-3]="!app?.isNative && !platform.IOS" [class.pb-6]="app?.isNative || platform.IOS"
                *ngIf="!this.app?.screen?.md && app?.footerStatus==='active'">


                <ng-container *ngIf="app?.footerType==='menu'">


                    <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
                        <mat-icon [svgIcon]="'mat_outline:apps'"></mat-icon>
                    </button>

                    <button mat-icon-button routerLink="/tasks">
                        <mat-icon svgIcon="mat_outline:task_alt"></mat-icon>
                    </button>

                    <button (click)="app?.emit('new')"
                        class="flex flex-col items-center  rounded-xl bg-primary-500  gap-4 px-1 py-1 text-default">
                        <mat-icon svgIcon="add" class="text-on-primary-500"> </mat-icon>
                    </button>

                    <button mat-icon-button routerLink="/calendar">
                        <mat-icon svgIcon="mat_outline:today"></mat-icon>
                    </button>

                    <auth-menu></auth-menu>
                </ng-container>
            </div>

        </div>

    </ng-container>



</ng-container>

<settings></settings>
